export { View as default } from 'react-native';



// WEBPACK FOOTER //
// ./src/@ui/SafeAreaView/index.web.js